import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="glossary-filter"
// Client-side search/filter for glossary term cards.
export default class extends Controller {
  static targets = ["input", "grid", "empty"]

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase()
    const cards = this.gridTarget.children
    let visible = 0

    for (const card of cards) {
      const term = (card.dataset.term || "").toLowerCase()
      const definition = (card.dataset.definition || "").toLowerCase()
      const match = !query || term.includes(query) || definition.includes(query)

      card.style.display = match ? "" : "none"
      if (match) visible++
    }

    this.emptyTarget.classList.toggle("hidden", visible > 0)
  }
}
